import BasePage from '../../../../../components/table_page';

export default {
  name: 'terminal_scanning_performance',
  extends: BasePage,
  data() {
    return {};
  },
  components: {

  },
  created() {
    this.getConfigList('main_list');
  },
  methods: {

    modalClick({ val, row }) {
      console.log('val', val);
    },
  },
};
